import { IDynamicAssigneeTooltipService } from "@gtmhub/assignees/components/dynamic-assignee-tooltip/dynamic-assignee-tooltip.service";
import { IItem } from "../models";

export const treeEvents = ["itemTitleClick", "itemRearrange", "showMoreClick", "toggleItemSupporters", "toggleItemSelf", "contextMenuOpen", "zoom"] as const;
export type TreeEvent = (typeof treeEvents)[number];

export type TreeEventListener = (evt: Event, ...args: unknown[]) => void;

export interface IItemRearrangeEventArgs {
  item: IItem;
  newParent: IItem;
}

export interface IZoomRange {
  min: number;
  max: number;
}

export interface ITreeMargin {
  left?: number;
  top?: number;
}

export interface ISvgSize {
  width: number;
  height: number;
}

export type ItemFilter = (item: IItem) => boolean;

export interface IItemRearrangeAllowed {
  start(item: IItem): boolean;
  end(item: IItem, newParent: IItem): boolean;
}

export const everyItem = (): boolean => true;

export interface IAlignmentTreeRendererOptions {
  offset?: {
    x: number;
    y: number;
  };
  tooltip: IDynamicAssigneeTooltipService;
  featureFlags?: {
    isCascadingShouldDecreaseToEnabled?: boolean;
  };
}

export interface AlignmentTreeActionHandlers {
  openCascadeMetricForm(item: IItem): void;
}
